export default __webpack_public_path__ + "static/media/banner-it-telecom-mobile-comp.0acbed5a.jpg";